/**
 * External dependencies
 */
import React from 'react';

/**
 * Internal dependencies
 */

import CloudHostingComponent from './main';

export const cloudhosting = (context, next) => {
    context.primary = <CloudHostingComponent />;
    next();
};

